import { render } from "./IndexClient.vue?vue&type=template&id=b3133818"
import script from "./IndexClient.vue?vue&type=script&lang=js"
export * from "./IndexClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__